import type { ReactElement } from 'react';
import Link from 'next/link';
import { Button } from '@/components/ui/button';
import { TwitterIcon } from '@/assets/social/twitter';

export default function Social(): ReactElement {
  return (
    <div className="w-fit flex items-center justify-center gap-1.5 sm:gap-3">
      <Link href="https://x.com" target="_blank">
        <Button
          variant="secondary"
          className="w-32 flex items-center gap-1 sm:gap-1.5 border hover:bg-border/5"
        >
          <TwitterIcon className="w-5 h-5" />
          <p>Twitter</p>
        </Button>
      </Link>
    </div>
  );
}
